export const WA_NUMBER = "628111106788";
export const PHONE_DISPLAY = "+62 811-1106-788";
export const EMAIL = "minaquhomenature@gmail.com";
export const WEBSITE = window.location.origin;
export const WEBSITE_HOST = window.location.host;
export const ADDRESS = "Jl. Raya Pondok Bitung, Sukamantri, Kec. Tamansari, Kabupaten Bogor, Jawa Barat 16610";
export const MAPS_URL = "https://maps.app.goo.gl/kiY77GtxTfuq6DUi9";

let LANG = "id";
export const setSiteLang = (l) => { LANG = l; };
export const getSiteLang = () => LANG;

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text || (LANG === "en" ? "Hello Minaqu Indonesia, I would like to ask about / order your plants." : "Halo Minaqu Indonesia, saya ingin bertanya/memesan."))}`;

export const SOCIALS = [
  { id: "instagram", label: "Instagram", handle: "@minaquhomenature", href: "https://www.instagram.com/minaquhomenature/" },
  { id: "tiktok", label: "TikTok", handle: "@minaqu.home.nature", href: "https://www.tiktok.com/@minaqu.home.nature?_r=1&_t=ZS-9AW63bLNB0a" },
  { id: "facebook", label: "Facebook", handle: "minaquhomenature", href: "https://www.facebook.com/minaquhomenature/?locale=id_ID" },
  { id: "linkedin", label: "LinkedIn", handle: "Minaqu Indonesia", href: "https://www.linkedin.com/company/minaqu-indonesia/mycompany/" },
];

export const SHOPS = [
  { id: "whatsapp", label: "Order by WhatsApp", handle: PHONE_DISPLAY, href: waLink() },
  { id: "shopee", label: "Order by Shopee", handle: "minaquhomenature", href: "https://shopee.co.id/minaquhomenature?page=1&searchKeyword=minaqu&sortBy=pop&tab=0" },
  { id: "tokopedia", label: "Order by Tokopedia", handle: "minaquindonesia", href: "https://tk.tokopedia.com/ZSbEsV5Tv/" },
];

export const DOCS = {
  about: "/assets/docs/company-profile-minaqu.pdf",
  plants: "/assets/docs/plants-catalogue-minaqu.pdf",
  souvenir: "/assets/docs/souvenir-catalogue-minaqu.pdf",
};

export const NAV = [
  { to: "/", label: "Beranda", en: "Home", id: "home" },
  { to: "/tentang-kami", label: "Tentang", en: "About", id: "about" },
  { to: "/katalog-tanaman", label: "Katalog Tanaman", en: "Plants Catalogue", id: "plants" },
  { to: "/kultur-jaringan", label: "Tissue Culture", en: "Tissue Culture", id: "tissue" },
  { to: "/souvenir-hampers", label: "Souvenir & Hampers", en: "Souvenir & Hampers", id: "souvenir" },
  { to: "/kontak", label: "Kontak", en: "Contact", id: "contact" },
];
